document.addEventListener("DOMContentLoaded", () => {
  const thumbnails = document.querySelectorAll(".thumbnail");
  const mainImage = document.getElementById("MainImage");
  const mainImageContainer = document.querySelector(".main-image");
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  let touchStartTime = 0;
  let hasMoved = false;
  const SWIPE_THRESHOLD = 50;
  const TAP_THRESHOLD = 200; // milliseconds
  const imageCache = new Map();

  // Append fullscreen viewer to body
  const fullscreenTemplate = `
    <div class="fullscreen-viewer">
      <button class="fullscreen-close-btn" aria-label="Close fullscreen view">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
      <div class="fullscreen-viewer__content">
        <button class="fullscreen-nav fullscreen-prev" aria-label="Previous media">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
        <div class="fullscreen-media-container">
          <img class="fullscreen-image" src="" alt="" style="display: none;" />
          <video class="fullscreen-video" controls style="display: none; width: 100%; height: 100%; object-fit: contain;">
            <source src="" type="">
          </video>
        </div>
        <button class="fullscreen-nav fullscreen-next" aria-label="Next media">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>
      </div>
    </div>`;

  document.body.insertAdjacentHTML("beforeend", fullscreenTemplate);

  // Add desktop navigation arrows
  if (mainImageContainer) {
    mainImageContainer.insertAdjacentHTML(
      "beforeend",
      `
      <button class="gallery-nav gallery-nav-prev" aria-label="Previous media">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </button>
      <button class="gallery-nav gallery-nav-next" aria-label="Next media">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </button>
    `
    );
  }

  // Get DOM elements
  const fullscreenViewer = document.querySelector(".fullscreen-viewer");
  const fullscreenImage = document.querySelector(".fullscreen-image");
  const fullscreenVideo = document.querySelector(".fullscreen-video");
  const closeBtn = document.querySelector(".fullscreen-close-btn");
  const nextBtn = document.querySelector(".fullscreen-next");
  const prevBtn = document.querySelector(".fullscreen-prev");
  const desktopPrevBtn = document.querySelector(".gallery-nav-prev");
  const desktopNextBtn = document.querySelector(".gallery-nav-next");

  function preloadAllImages() {
    thumbnails.forEach((thumbnail) => {
      const thumbnailImg = thumbnail.querySelector("img");
      if (thumbnailImg) {
        const baseUrl = thumbnailImg.src.split("?")[0];
        const sizes = [800, 1200, 1600];

        sizes.forEach((size) => {
          const imageUrl = `${baseUrl}?width=${size}`;
          if (!imageCache.has(imageUrl)) {
            const img = new Image();
            img.onload = () => {
              imageCache.set(imageUrl, img);
            };
            img.src = imageUrl;
          }
        });
      }
    });
  }

  function getOptimizedImageUrls(thumbnailImg) {
    const baseUrl = thumbnailImg.src.split("?")[0];
    return {
      srcset: `
        ${baseUrl}?width=800 800w,
        ${baseUrl}?width=1200 1200w,
        ${baseUrl}?width=1600 1600w
      `,
      sizes: "(max-width: 800px) 800px, (max-width: 1200px) 1200px, 1600px",
      src: `${baseUrl}?width=1200`,
    };
  }

  function createMainVideo(videoUrl, thumbnailSources) {
    const video = document.createElement('video');
    video.id = 'MainVideo';
    video.className = 'main-video';
    video.setAttribute('width', '100%');
    video.setAttribute('height', '100%');
    // video.setAttribute('controls', '');
    video.setAttribute('autoplay', '');
     video.setAttribute('loop', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.style.objectFit = 'contain';
    video.style.width = '100%';
    video.style.height = '100%';

    // Add sources from thumbnail
    if (thumbnailSources && thumbnailSources.length > 0) {
      thumbnailSources.forEach(source => {
        const sourceElement = document.createElement('source');
        sourceElement.src = source.url;
        sourceElement.type = source.mime_type;
        video.appendChild(sourceElement);
      });
    } else if (videoUrl) {
      video.src = videoUrl;
    }

    return video;
  }

  function updateMainImage(thumbnail) {
    if (!thumbnail || !mainImageContainer) return;

    thumbnails.forEach((thumb) => thumb.classList.remove("active"));
    thumbnail.classList.add("active");

    const mediaType = thumbnail.getAttribute("data-media-type");
    
    // Remove existing main video if it exists
    const existingVideo = document.getElementById('MainVideo');
    if (existingVideo) {
      existingVideo.remove();
    }

    if (mediaType === 'video') {
      // Hide main image
      if (mainImage) {
        mainImage.style.display = 'none';
      }

      // Get video data
      const videoUrl = thumbnail.getAttribute("data-video-url");
      const thumbnailVideo = thumbnail.querySelector('video');
      let videoSources = [];
      
      if (thumbnailVideo) {
        const sources = thumbnailVideo.querySelectorAll('source');
        sources.forEach(source => {
          videoSources.push({
            url: source.src,
            mime_type: source.type
          });
        });
      }

      // Create and add main video
      const mainVideo = createMainVideo(videoUrl, videoSources);
      mainImageContainer.appendChild(mainVideo);

      // Add fade-in effect
      mainVideo.style.opacity = "0";
      requestAnimationFrame(() => {
        mainVideo.style.transition = "opacity 0.2s ease-in-out";
        mainVideo.style.opacity = "1";
      });

    } else {
      // Show main image and hide any video
      if (mainImage) {
        mainImage.style.display = 'block';
        
        const thumbnailImg = thumbnail.querySelector("img");
        if (thumbnailImg) {
          const { srcset, sizes, src } = getOptimizedImageUrls(thumbnailImg);

          if (imageCache.has(src)) {
            mainImage.src = imageCache.get(src).src;
          } else {
            mainImage.src = src;
          }

          mainImage.srcset = srcset;
          mainImage.sizes = sizes;
          mainImage.alt = thumbnail.getAttribute("data-media-alt") || "";

          mainImage.style.opacity = "0";
          requestAnimationFrame(() => {
            mainImage.style.transition = "opacity 0.2s ease-in-out";
            mainImage.style.opacity = "1";
          });
        }
      }
    }
  }

  function openFullscreen(thumbnail) {
    const mediaType = thumbnail.getAttribute("data-media-type");
    
    if (mediaType === 'video') {
      // Show video in fullscreen
      fullscreenImage.style.display = 'none';
      fullscreenVideo.style.display = 'block';
      
      const videoUrl = thumbnail.getAttribute("data-video-url");
      const thumbnailVideo = thumbnail.querySelector('video');
      
      if (thumbnailVideo) {
        const sources = thumbnailVideo.querySelectorAll('source');
        // Clear existing sources
        fullscreenVideo.innerHTML = '';
        
        sources.forEach(source => {
          const sourceElement = document.createElement('source');
          sourceElement.src = source.src;
          sourceElement.type = source.type;
          fullscreenVideo.appendChild(sourceElement);
        });
      } else if (videoUrl) {
        fullscreenVideo.src = videoUrl;
      }
      
      fullscreenVideo.load(); // Reload video with new sources
    } else {
      // Show image in fullscreen
      fullscreenVideo.style.display = 'none';
      fullscreenImage.style.display = 'block';
      
      const thumbnailImg = thumbnail.querySelector("img");
      if (thumbnailImg) {
        const { src } = getOptimizedImageUrls(thumbnailImg);
        fullscreenImage.src = src;
        fullscreenImage.alt = thumbnail.getAttribute("data-media-alt") || "";
      }
    }
    
    fullscreenViewer.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeFullscreen() {
    fullscreenViewer.classList.remove("active");
    document.body.style.overflow = "";
    
    // Pause fullscreen video if playing
    if (fullscreenVideo && !fullscreenVideo.paused) {
      fullscreenVideo.pause();
    }
  }

  function getVisibleThumbnails() {
    return Array.from(thumbnails).filter(
      (thumb) => !thumb.classList.contains("hidden")
    );
  }

  function getCurrentIndex() {
    const visibleThumbs = getVisibleThumbnails();
    return visibleThumbs.findIndex((thumb) =>
      thumb.classList.contains("active")
    );
  }

  function navigateGallery(direction) {
    const visibleThumbs = getVisibleThumbnails();
    const currentIndex = getCurrentIndex();
    const newIndex = currentIndex + direction;

    if (newIndex >= 0 && newIndex < visibleThumbs.length) {
      const newThumbnail = visibleThumbs[newIndex];
      updateMainImage(newThumbnail);
      
      newThumbnail.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });

      if (fullscreenViewer.classList.contains("active")) {
        openFullscreen(newThumbnail);
      }
    }
  }

  function handleSwipe(swipeDistance) {
    if (Math.abs(swipeDistance) < SWIPE_THRESHOLD) return;

    if (swipeDistance > 0) {
      navigateGallery(1); // Next media
    } else {
      navigateGallery(-1); // Previous media
    }
  }

  // Updated touch handlers
  const handleTouchStart = (e) => {
    startX = e.touches[0].clientX;
    touchStartTime = Date.now();
    hasMoved = false;
    isDragging = true;
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;

    // Only set hasMoved if there's significant movement
    if (Math.abs(currentX - startX) > 10) {
      hasMoved = true;
    }
  };

  const handleTouchEnd = () => {
    if (!isDragging) return;

    const touchDuration = Date.now() - touchStartTime;
    const activeThumbnail = document.querySelector('.thumbnail.active');

    // If it's a quick tap without much movement, trigger fullscreen
    if (!hasMoved && touchDuration < TAP_THRESHOLD && activeThumbnail) {
      openFullscreen(activeThumbnail);
    }
    // Otherwise, handle as swipe if movement threshold is met
    else if (hasMoved) {
      handleSwipe(startX - currentX);
    }

    isDragging = false;
    hasMoved = false;
    startX = currentX = 0;
  };

  const handleMouseDown = (e) => {
    startX = e.clientX;
    touchStartTime = Date.now();
    hasMoved = false;
    isDragging = true;
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    currentX = e.clientX;
    if (Math.abs(currentX - startX) > 10) {
      hasMoved = true;
    }
  };

  const handleMouseUp = () => {
    if (!isDragging) return;

    const touchDuration = Date.now() - touchStartTime;
    const activeThumbnail = document.querySelector('.thumbnail.active');

    if (!hasMoved && touchDuration < TAP_THRESHOLD && activeThumbnail) {
      openFullscreen(activeThumbnail);
    } else if (hasMoved) {
      handleSwipe(startX - currentX);
    }

    isDragging = false;
    hasMoved = false;
    startX = currentX = 0;
  };

  // Event listeners for main media area
  if (mainImageContainer) {
    mainImageContainer.addEventListener("touchstart", handleTouchStart, {
      passive: true,
    });
    mainImageContainer.addEventListener("touchmove", handleTouchMove, { passive: true });
    mainImageContainer.addEventListener("touchend", handleTouchEnd, { passive: true });

    mainImageContainer.addEventListener("mousedown", handleMouseDown, { passive: true });
    mainImageContainer.addEventListener("mousemove", handleMouseMove, { passive: true });
    mainImageContainer.addEventListener("mouseup", handleMouseUp, { passive: true });
    mainImageContainer.addEventListener("mouseleave", handleMouseUp, { passive: true });
  }

  // Fullscreen controls
  if (closeBtn) closeBtn.addEventListener("click", closeFullscreen);
  if (nextBtn) nextBtn.addEventListener("click", () => navigateGallery(1));
  if (prevBtn) prevBtn.addEventListener("click", () => navigateGallery(-1));
  if (desktopNextBtn) desktopNextBtn.addEventListener("click", () => navigateGallery(1));
  if (desktopPrevBtn) desktopPrevBtn.addEventListener("click", () => navigateGallery(-1));

  // Keyboard navigation
  document.addEventListener("keydown", (e) => {
    if (!fullscreenViewer.classList.contains("active")) return;

    if (e.key === "Escape") closeFullscreen();
    if (e.key === "ArrowRight") navigateGallery(1);
    if (e.key === "ArrowLeft") navigateGallery(-1);
  });

  // Close fullscreen on background click
  if (fullscreenViewer) {
    fullscreenViewer.addEventListener("click", (e) => {
      if (e.target === fullscreenViewer) {
        closeFullscreen();
      }
    });
  }

  // Event delegation for thumbnails
  const thumbnailContainer = thumbnails[0]?.parentElement;
  if (thumbnailContainer) {
    thumbnailContainer.addEventListener(
      "click",
      (e) => {
        const thumbnail = e.target.closest(".thumbnail");
        if (thumbnail) {
          updateMainImage(thumbnail);
        }
      },
      { passive: true }
    );
  }

  // Initialize gallery
  if (thumbnails.length > 0) {
    updateMainImage(thumbnails[0]);
    preloadAllImages();
  }

  // Variant Image Filter
  class VariantImageFilter {
    constructor() {
      const mediaWrapper = document.querySelector(".product__media-wrapper");
      if (!mediaWrapper) return;

      try {
        const variantsJson = mediaWrapper.getAttribute("data-variants");
        this.variants = JSON.parse(variantsJson);

        document.addEventListener(
          "variant:changed",
          this.handleVariantChange.bind(this)
        );

        const variantSelectors = document.querySelectorAll(
          'select[name^="options"], input[type="radio"][name^="options"], .variant-input'
        );
        variantSelectors.forEach((selector) => {
          selector.addEventListener(
            "change",
            this.handleSelectorChange.bind(this)
          );
        });

        this.handleInitialVariant();
      } catch (error) {
        console.error("Error initializing VariantImageFilter:", error);
      }
    }

    handleVariantChange(event) {
      if (event.detail && event.detail.variant) {
        this.updateVariantImages(event.detail.variant);
      }
    }

    handleSelectorChange() {
      const selectedOptions = [];
      const optionSelectors = document.querySelectorAll(
        'select[name^="options"], input[type="radio"][name^="options"]:checked, .variant-input:checked'
      );

      optionSelectors.forEach((selector) => {
        selectedOptions.push(selector.value);
      });

      const matchingVariant = this.variants.find((variant) => {
        const variantOptions = variant.options || variant.title.split(" / ");
        return selectedOptions.every((option) =>
          variantOptions.includes(option)
        );
      });

      if (matchingVariant) {
        this.updateVariantImages(matchingVariant);
      }
    }

    getCurrentThumbnailIndex() {
      const thumbnails = document.querySelectorAll(".thumbnail:not(.hidden)");
      const activeThumb = document.querySelector(".thumbnail.active");
      return activeThumb ? Array.from(thumbnails).indexOf(activeThumb) : 0;
    }

    updateVariantImages(variant) {
      if (!variant) return;

      const variantTitle = variant.title.split(" / ")[0].trim();
      const currentIndex = this.getCurrentThumbnailIndex();
      const thumbnails = document.querySelectorAll(".thumbnail");
      const visibleThumbnails = [];

      thumbnails.forEach((thumbnail) => {
        const mediaAlt = thumbnail.getAttribute("data-media-alt");
        if (mediaAlt === variantTitle || mediaAlt === "common") {
          thumbnail.style.display = "";
          thumbnail.classList.remove("hidden");
          visibleThumbnails.push(thumbnail);
        } else {
          thumbnail.style.display = "none";
          thumbnail.classList.add("hidden");
        }
      });

      if (visibleThumbnails.length > 0) {
        const targetIndex = Math.min(
          currentIndex,
          visibleThumbnails.length - 1
        );
        if (visibleThumbnails[targetIndex]) {
          updateMainImage(visibleThumbnails[targetIndex]);
          visibleThumbnails[targetIndex].scrollIntoView({
            behavior: "auto",
            block: "nearest",
          });
        }
      }
    }

    handleInitialVariant() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get("variant");

      if (variantId) {
        const variant = this.variants.find(
          (v) => v.id.toString() === variantId
        );
        if (variant) {
          this.updateVariantImages(variant);
          return;
        }
      }

      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        const variant = this.variants.find(
          (v) => v.id.toString() === variantInput.value
        );
        if (variant) {
          this.updateVariantImages(variant);
        }
      }
    }
  }

  // Initialize the VariantImageFilter
  new VariantImageFilter();
});